import { render } from "./EnvironmentsBar.vue?vue&type=template&id=a70422be&scoped=true&ts=true"
import script from "./EnvironmentsBar.vue?vue&type=script&lang=ts"
export * from "./EnvironmentsBar.vue?vue&type=script&lang=ts"

import "./EnvironmentsBar.vue?vue&type=style&index=0&id=a70422be&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a70422be"]])

export default __exports__